import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import { useDialog } from '../../contexts/dialog';
import { ButtonContained, CustomDialogContent, CustomDialogTitle, TypographyDialogContent } from './styles';

type DialogProps = {
  openDialog: boolean;
  // setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenDialog: (status: boolean) => void;
  dialogText?: string;
  handleCloseLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  handleClearIframeSrc?: React.Dispatch<React.SetStateAction<any>>;
};

const SimpleDialog = ({
  dialogText,
  handleCloseLoading,
  handleClearIframeSrc,
}: DialogProps) => {
  const dialog = useDialog();

  const handleCloseDialog = () => {
    dialog.setDialogStatus(false);
  };

  const handleClearIframe = () => {
    dialog.setDialogStatus(false);
    handleClearIframeSrc!(null);
    handleCloseLoading!(false);
  }

  return (
    <div>
      <Dialog
        open={dialog.dialogStatus}
        onClose={handleClearIframe}
        aria-labelledby="form-dialog-title"
      >
        <CustomDialogTitle id="form-dialog-title"></CustomDialogTitle>
        <CustomDialogContent>
          <DialogContentText><TypographyDialogContent>{dialogText}</TypographyDialogContent></DialogContentText>
        </CustomDialogContent>
        <DialogActions>
          <ButtonContained onClick={handleCloseDialog} variant="outlined">
            OK
          </ButtonContained>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SimpleDialog;
